export const asgariUcret = [
    {
        year: 2005,
        price: 350.15,
        dollar: 1.3505
    },
    {
        year: 2006,
        price: 380.46,
        dollar: 1.4155
    },
    {
        year: 2007,
        price: 419.15,
        dollar: 1.1677
    },
    {
        year: 2008,
        price: 503.26,
        dollar: 1.5405
    },
    {
        year: 2009,
        price: 546.48,
        dollar: 1.5002
    },
    {
        year: 2010,
        price: 599.12,
        dollar: 1.5419
    },
    {
        year: 2011,
        price: 658.95,
        dollar: 1.8840
    },
    {
        year: 2012,
        price: 739.79,
        dollar: 1.7817
    },
    {
        year: 2013,
        price: 803.68,
        dollar: 2.1450
    },
    {
        year: 2014,
        price: 891.03,
        dollar: 2.3335
    },
    {
        year: 2015,
        price: 1000.54,
        dollar: 2.9167
    },
    {
        year: 2016,
        price:1300.99,
        dollar: 3.5267
    },
    {
        year: 2017,
        price: 1404.06,
        dollar: 3.7890
    },
    {
        year: 2018,
        price: 1603.12,
        dollar: 5.2877
    },
    {
        year: 2019,
        price: 2020,
        dollar: 5.9479
    },
    {
        year: 2020,
        price: 2324,
        dollar: 7.4320
    },
    {
        year: 2021,
        price: 2825.90,
        dollar: 11.2360
    }
]